import "./NotificationsListModalSkeleton.scss";

export const NotificationsListModalSkeleton = () => {
  return (
    <div className="docs-skeleton-container">
      {/* Column of Skeleton Documents */}
      {[...Array(3)].map((_, index) => (
        <div className="docs-skeleton-document" key={index}>
          <div className="docs-skeleton-document-header">
            <div className="docs-skeleton-emesso pulse"></div>
            <div className="docs-skeleton-date pulse"></div>
          </div>
          <div className="docs-skeleton-document-content">
            <div className="docs-skeleton-document-type pulse"></div>
            <div className="docs-skeleton-document-title pulse"></div>
            <div className="docs-skeleton-document-tag pulse"></div>
            <div className="docs-skeleton-document-comments pulse"></div>
            <div className="docs-skeleton-document-footer">
              <div className="docs-skeleton-document-link pulse"></div>
              <div className="docs-skeleton-document-button pulse"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
